export default "__VITE_ASSET__DXcF4jEL__"